module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 008.1674afc9.jpg";